// angular
// 	.module("HeroPRO")
// 	.controller("ParticipantVsCertifiedProfessionalComparisonController", ParticipantVsCertifiedProfessionalComparisonController);

import _ from 'lodash';

import './ParticipantVsCertifiedProfessionalComparison.scss';

/* @ngInject */
export default function ParticipantVsCertifiedProfessionalComparisonController($uibModalInstance) {
    const vm = this;

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.closeModal = function () {
        $uibModalInstance.close();
    };

    /*= =======================================
    =            Private Functions           =
    ======================================== */

    function init() {
    }

    init();

    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/accounts/user/paceCredential/modals/ParticipantVsCertifiedProfessionalComparisonController.js